<template>
  <section class="wrapper">
    <!--    <header>-->
    <!--      <div class="head">-->
    <!--        <a @click="T2()"><img src="../../static/img/04.png" alt="" /></a>-->
    <!--        <h2>图片中心</h2>-->
    <!--        <a href="javascript:;">显示图片</a>-->
    <!--      </div>-->
    <!--    </header>-->
    <!--    <div class="conT"></div>-->
    <!--    <div class="Cmain">-->
    <!--      <ul>-->
    <!--        <li>-->
    <img id="img" src="../assets/img/02.png" alt="">
    <!--    </li>-->
    <!--      </ul>-->
    <!--    </div>-->
  </section>
</template>
<script>
  import webFooter from "./layout/components/Footer";
  import {MessageBox} from "mint-ui";
  import homeVue from './home.vue';

  export default {
    name: "GetImg",
    components: {
      webFooter,
    },

    data() {
      return {};
    },
    mounted: function () {
      this.t1();
      //this.GetImg();
    },
    methods: {

      t1() {

        var imgGuid = sessionStorage.getItem('imgGuid');
        // alert(imgGuid);
      },
      GetImg() {
        var imgGuid = sessionStorage.getItem('imgGuid');
        if (imgGuid == "") {
          $("#img").attr("src", null)
        } else {
          $("#img").attr("src", "../../static/img/04.png")
        }
      },

      T2() {
        this.$router.push('/man')
      },
    },
  }


</script>

<style scoped>
  html,
  body {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  /*大盒子，首位固定*/
  .bothbox {
    display: flex;
    flex-direction: column;
    height: 100vh;
    position: relative;
  }

  /*头部固定*/
  header {
    height: 0.35rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    border-bottom: 1px solid #e9e9e9;
  }

  /*头部标题*/
  .head {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 0.13rem;
    color: black;
  }

  /*标题样式*/
  .head h2 {
    display: block;
    width: 2.5rem;
    text-align: center;
    margin-left: 28px;
  }

  .head img {
    width: 0.18rem;
    height: 0.18rem;
  }

  .head a {
    color: #585858;
  }

  /*中间部分*/
  section {
    flex: 1;
    height: 100%;
    overflow: auto;
    position: relative;
    background: white;
  }

  .conT {
    height: 0.4rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #fbfafa;
  }

  .conBoth {
    width: 0.95rem;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    margin-left: 0.1rem;
  }

  .conBoth a {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .conBoth a p {
    font-size: 0.12rem;
    color: #30302f;
    margin-right: 0.05rem;
  }

  .conBoth a img {
    width: 0.07rem;
    height: 0.05rem;
  }

  .conMain {
    height: 0.7rem;
    padding-top: 0.15rem;
    border-bottom: 0.05rem solid #f4f4f4;
  }

  .conMain ul {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .conMain ul li {
    width: 40%;
    height: 0.62rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.1rem;
    color: #8d8d8d;
  }

  .conMain ul li a img {
    width: 0.36rem;
    height: 0.36rem;
  }

  .Cmain {
    height: 0.8rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  .btn {
    display: block;
    width: 0.15rem;
    height: 0.15rem;
    border: 1px solid #dddddc;
    border-radius: 50%;
  }

  .Cmain li {
    height: 0.63rem;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    border-bottom: 1px solid #e9e9e9;
  }

  .Cmain li p:first-child {
    width: 0.37rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Cmain li p:first-child img {
    width: 0.25rem;
    height: 0.29rem;
  }

  .Cmain li p:nth-child(2) {
    width: 2.4rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-size: 0.13rem;
    color: black;
  }

  .Cmain li p:nth-child(2) span {
    font-size: 0.09rem;
    color: #7d7d7d;
  }

  .Cmain li a {
    font-size: 0.12rem;
    color: #cbcbcb;
  }
</style>
